import axios from '@/config/httpConfig'

// 获取应用程序列表
export function getApplicationList (data) {
  return axios.post('/application/getApplicationList', data)
}
//获取伙伴云用户菜单
export function getPartnerTab() {
  return axios.post('partner/getTabList')
}